<template>
<div class="unm-header">
  <div class="navbar navbar-unm">
    <div class="container"><a class="navbar-brand" href="https://degrees.unm.edu">The University of New
        Mexico</a>

      <ul class="nav navbar-nav navbar-right hidden-xs" id="toolbar-nav">
        <li><a href="https://directory.unm.edu/departments/" title="UNM A to Z">UNM A-Z</a></li>
        <li><a href="https://my.unm.edu" title="myUNM">myUNM</a></li>
        <li><a href="https://directory.unm.edu" title="Directory">Directory</a></li>
      </ul>
    </div>
  </div>

  <div aria-label="department logo block" id="header" role="banner">
    <div class="container">
      <!-- <nav aria-label="Secondary Navigation" class="navbar-collapse collapse" id="top-nav">
        <ul class="nav navbar-nav navbar-right" role="menubar">
          <li><a href="welcome/index.html">About UNM</a></li>
          <li><a href="academics/index.html">Academics</a></li>
          <li><a href="campus-life/index.html">Campus Life</a></li>
          <li><a href="research/index.html">Research</a></li>
          <li><a href="https://www.unmfund.org/">Give to UNM</a></li>
        </ul>
      </nav> -->
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: 'Header'
  }
</script>



// WEBPACK FOOTER //
// unm_header.vue?8e06967c